module.exports = __webpack_public_path__ + "img/ic-dinners-no-color.d6303e41.svg";